import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL_NEW } from '@utils/api/endpoints.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import { ExportTemplateItemsResponse } from '@utils/types/organization/export-template-item.ts';
import { PagedListParams } from '@utils/api/endpoints.paged.ts.tsx';
import { BaseError } from '@utils/types/shared/base.ts';

export const useGetExportTemplateItems = (
  params?: PagedListParams,
  options?: UseQueryOptions<
    ExportTemplateItemsResponse,
    AxiosError<BaseError>,
    ExportTemplateItemsResponse,
    (string | PagedListParams | undefined)[]
  >
) => {
  const fetch = async (): Promise<ExportTemplateItemsResponse> => {
    const url = GET_URL_NEW(params).exportTemplateItems;
    const { data } = await Axios.get<ExportTemplateItemsResponse>(url);
    return data;
  };

  return useQuery<
    ExportTemplateItemsResponse,
    AxiosError<BaseError>,
    ExportTemplateItemsResponse,
    (string | PagedListParams | undefined)[]
  >([...QueryKeys.exportTemplateItems(), params], fetch, {
    ...options
  });
};
